import React, { useState } from 'react';
import LogoIcon from '../svg/LogoIcon';
import Burger from './Burger/Burger';
import MainForm from '../components/MainForm';
import ohio_bg from '../svg/ohio_bg.jpg';
import VariableRateInfo from '../components/VariableRateInfo';
import FeaturedBlog from '../components/FeaturedBlog';
import { Fade } from 'react-reveal';

const App = () => {
  //TopZip States/////////////////////////////////////////////////////
  //Dominion Zip Codes//
  const ZipDominion = [
    '43006',
    '43014',
    '43532',
    '43716',
    '43747',
    '42752',
    '42754',
    '42754',
    '42757',
    '43789',
    '43793',
    '43793',
    '43804',
    '43840',
    '43942',
    '43946',
    '44004',
    '44010',
    '44021',
    '44021',
    '44022',
    '44022',
    '44022',
    '44023',
    '44023',
    '44023',
    '44023',
    '44024',
    '44026',
    '44030',
    '44033',
    '44040',
    '44041',
    '44041',
    '44045',
    '44046',
    '44047',
    '44048',
    '44056',
    '44056',
    '44057',
    '44060',
    '44060',
    '44060',
    '44062',
    '44064',
    '44065',
    '44067',
    '44067',
    '44067',
    '44068',
    '44070',
    '44072',
    '44072',
    '44077',
    '44077',
    '44077',
    '44077',
    '44081',
    '44082',
    '44086',
    '44087',
    '44088',
    '44092',
    '44092',
    '44094',
    '44094',
    '44094',
    '44094',
    '44095',
    '44095',
    '44095',
    '44095',
    '44095',
    '44099',
    '44101',
    '44102',
    '44103',
    '44104',
    '44105',
    '44105',
    '44105',
    '44106',
    '44106',
    '44107',
    '44107',
    '44108',
    '44108',
    '44109',
    '44110',
    '44110',
    '44110',
    '44111',
    '44112',
    '44112',
    '44112',
    '44113',
    '44114',
    '44115',
    '44116',
    '44116',
    '44117',
    '44117',
    '44118',
    '44118',
    '44118',
    '44118',
    '44118',
    '44118',
    '44118',
    '44118',
    '44119',
    '44119',
    '44120',
    '44120',
    '44121',
    '44121',
    '44121',
    '44122',
    '44122',
    '44122',
    '44122',
    '44122',
    '44122',
    '44122',
    '44122',
    '44123',
    '44123',
    '44124',
    '44124',
    '44124',
    '44124',
    '44125',
    '44125',
    '44125',
    '44125',
    '44126',
    '44126',
    '44127',
    '44128',
    '44128',
    '44128',
    '44128',
    '44128',
    '44128',
    '44128',
    '44129',
    '44130',
    '44131',
    '44131',
    '44131',
    '44131',
    '44131',
    '44132',
    '44132',
    '44133',
    '44134',
    '44134',
    '44135',
    '44137',
    '44137',
    '44139',
    '44139',
    '44141',
    '44141',
    '44142',
    '44142',
    '44142',
    '44143',
    '44143',
    '44143',
    '44143',
    '44143',
    '44143',
    '44143',
    '44143',
    '44144',
    '44144',
    '44145',
    '44146',
    '44146',
    '44146',
    '44146',
    '44146',
    '44146',
    '44147',
    '44147',
    '44147',
    '44199',
    '44201',
    '44202',
    '44202',
    '44203',
    '44203',
    '44203',
    '44210',
    '44211',
    '44216',
    '44216',
    '44217',
    '44221',
    '44223',
    '44224',
    '44224',
    '44224',
    '44224',
    '44230',
    '44231',
    '44232',
    '44233',
    '44234',
    '44236',
    '44240',
    '44241',
    '44250',
    '44255',
    '44256',
    '44260',
    '44262',
    '44264',
    '44265',
    '44266',
    '44270',
    '44272',
    '44273',
    '44278',
    '44281',
    '44282',
    '44286',
    '44288',
    '44301',
    '44302',
    '44303',
    '44304',
    '44305',
    '44306',
    '44307',
    '44308',
    '44309',
    '44310',
    '44311',
    '44312',
    '44313',
    '44314',
    '44316',
    '44317',
    '44319',
    '44319',
    '44320',
    '44321',
    '44321',
    '44322',
    '44325',
    '44326',
    '44328',
    '44333',
    '44333',
    '44401',
    '44402',
    '44403',
    '44405',
    '44406',
    '44410',
    '44411',
    '44412',
    '44413',
    '44413',
    '44418',
    '44420',
    '44425',
    '44429',
    '44430',
    '44436',
    '44437',
    '44440',
    '44442',
    '44443',
    '44444',
    '44446',
    '44451',
    '44452',
    '44453',
    '44454',
    '44470',
    '44471',
    '44473',
    '44481',
    '44482',
    '44483',
    '44484',
    '44485',
    '44491',
    '44501',
    '44502',
    '44503',
    '44504',
    '44505',
    '44506',
    '44507',
    '44509',
    '44510',
    '44511',
    '44512',
    '44512',
    '44513',
    '44514',
    '44514',
    '44515',
    '44515',
    '44515',
    '44555',
    '44601',
    '44606',
    '44609',
    '44612',
    '44614',
    '44614',
    '44618',
    '44621',
    '44622',
    '44626',
    '44628',
    '44629',
    '44630',
    '44632',
    '44636',
    '44638',
    '44640',
    '44641',
    '44643',
    '44645',
    '44646',
    '44647',
    '44650',
    '44652',
    '44653',
    '44656',
    '44662',
    '44663',
    '44663',
    '44666',
    '44667',
    '44671',
    '44676',
    '44677',
    '44680',
    '44681',
    '44682',
    '44683',
    '44685',
    '44688',
    '44691',
    '44701',
    '44702',
    '44703',
    '44704',
    '44705',
    '44706',
    '44707',
    '44708',
    '44709',
    '44709',
    '44710',
    '44711',
    '44712',
    '44714',
    '44718',
    '44720',
    '44720',
    '44721',
    '44721',
    '44730',
    '44730',
    '44824',
    '44842',
    '45349',
    '45612',
    '45712',
    '45714',
    '45723',
    '45729',
    '45734',
    '45734',
    '45742',
    '45744',
    '45750',
    '45767',
    '45767',
    '45767',
    '45767',
    '45768',
    '45773',
    '45784',
    '45786',
    '45788',
    '45789',
    '43326',
    '45302',
    '45306',
    '45801',
    '45801',
    '45804',
    '45805',
    '45806',
    '45806',
    '45807',
    '45807',
    '45808',
    '45815',
    '45817',
    '45820',
    '45821',
    '45822',
    '45826',
    '45827',
    '45828',
    '45830',
    '45830',
    '45832',
    '45833',
    '45844',
    '45846',
    '45848',
    '45850',
    '45851',
    '45854',
    '45856',
    '45863',
    '45866',
    '45873',
    '45874',
    '45875',
    '45877',
    '45879',
    '45882',
    '45883',
    '45885',
    '45886',
    '45887',
    '45891',
    '45895',
    '45898'
  ];
  //Columbia Zip Codes
  const ZipColumbia = [
    '45810',
    '43802',
    '43101',
    '44801',
    '44321',
    '45710',
    '43001',
    '45812',
    '43902',
    '45611',
    '44601',
    '44802',
    '43102',
    '45711',
    '44001',
    '43002',
    '43903',
    '44606',
    '44804',
    '43904',
    '44805',
    '43003',
    '43103',
    '45701',
    '44807',
    '44011',
    '44012',
    '45872',
    '43105',
    '45712',
    '43713',
    '45713',
    '44809',
    '44140',
    '44608',
    '44146',
    '43906',
    '43310',
    '43717',
    '44811',
    '44813',
    '43718',
    '44609',
    '45714',
    '44017',
    '43908',
    '44610',
    '44401',
    '44814',
    '43719',
    '45715',
    '45614',
    '44611',
    '44816',
    '43004',
    '43005',
    '43909',
    '44817',
    '43910',
    '44818',
    '43720',
    '44612',
    '43402',
    '43406',
    '43107',
    '44613',
    '43109',
    '43912',
    '43913',
    '43006',
    '44147',
    '44212',
    '45716',
    '43008',
    '44820',
    '43722',
    '44214',
    '44822',
    '43723',
    '43907',
    '43724',
    '43314',
    '43725',
    '43110',
    '44406',
    '43111',
    '43315',
    '43316',
    '43112',
    '44615',
    '44824',
    '43011',
    '43727',
    '44617',
    '45719',
    '45619',
    '45620',
    '45720',
    '43728',
    '45601',
    '44215',
    '43113',
    '43915',
    '43408',
    '43729',
    '44149',
    '43410',
    '43711',
    '45721',
    '45621',
    '44826',
    '43062',
    '44028',
    '44408',
    '43085',
    '43201',
    '43202',
    '43203',
    '43205',
    '43206',
    '43207',
    '43208',
    '43209',
    '43210',
    '43211',
    '43212',
    '43213',
    '43214',
    '43215',
    '43216',
    '43217',
    '43218',
    '43219',
    '43220',
    '43222',
    '43223',
    '43224',
    '43225',
    '43227',
    '43229',
    '43231',
    '43232',
    '43235',
    '43236',
    '43240',
    '43266',
    '43204',
    '43221',
    '43228',
    '43116',
    '43811',
    '45723',
    '44333',
    '43730',
    '44410',
    '43812',
    '45622',
    '44827',
    '44217',
    '43731',
    '43013',
    '43732',
    '43412',
    '45724',
    '43413',
    '44618',
    '44619',
    '43014',
    '43015',
    '43515',
    '43117',
    '43733',
    '45727',
    '44412',
    '45319',
    '44622',
    '43821',
    '43016',
    '43017',
    '44624',
    '43735',
    '43319',
    '43920',
    '44413',
    '44625',
    '44626',
    '43320',
    '44415',
    '43416',
    '44035',
    '44036',
    '43926',
    '45323',
    '43018',
    '45324',
    '43804',
    '45839',
    '45840',
    '44828',
    '45729',
    '43977',
    '44829',
    '44830',
    '45629',
    '43822',
    '44627',
    '43019',
    '43420',
    '43824',
    '43321',
    '43738',
    '43230',
    '43021',
    '44833',
    '45631',
    '43119',
    '43022',
    '43430',
    '43431',
    '43149',
    '43928',
    '43739',
    '44628',
    '45732',
    '44629',
    '44044',
    '43023',
    '45734',
    '43322',
    '44836',
    '44837',
    '43123',
    '43125',
    '43741',
    '45735',
    '43433',
    '45633',
    '45634',
    '43930',
    '45635',
    '43931',
    '44423',
    '44631',
    '43323',
    '43126',
    '45850',
    '43127',
    '44838',
    '43025',
    '43435',
    '43743',
    '43026',
    '44233',
    '45739',
    '43528',
    '44633',
    '43027',
    '44235',
    '44634',
    '43976',
    '43746',
    '43028',
    '44839',
    '43325',
    '43932',
    '45638',
    '45640',
    '43030',
    '45740',
    '43933',
    '44840',
    '43986',
    '43031',
    '43748',
    '44427',
    '43326',
    '45643',
    '43032',
    '44637',
    '43749',
    '45644',
    '44049',
    '43033',
    '45645',
    '43332',
    '43439',
    '44050',
    '43331',
    '44638',
    '43130',
    '45741',
    '43934',
    '43135',
    '44430',
    '45036',
    '44431',
    '43441',
    '43035',
    '42754',
    '45804',
    '43442',
    '44432',
    '44253',
    '43136',
    '45742',
    '43137',
    '44254',
    '43138',
    '43140',
    '45647',
    '45743',
    '44054',
    '44055',
    '44052',
    '44053',
    '42755',
    '44842',
    '45744',
    '45745',
    '44843',
    '45648',
    '45699',
    '43443',
    '43036',
    '44643',
    '42758',
    '44644',
    '44901',
    '44902',
    '44903',
    '44905',
    '44906',
    '44907',
    '44904',
    '43440',
    '43334',
    '45750',
    '43301',
    '43302',
    '43445',
    '43935',
    '43037',
    '43040',
    '44646',
    '44647',
    '43537',
    '45651',
    '42756',
    '44844',
    '45859',
    '43044',
    '44651',
    '44256',
    '44258',
    '44130',
    '44062',
    '45760',
    '44846',
    '43045',
    '43447',
    '44654',
    '43046',
    '45761',
    '44656',
    '44657',
    '45653',
    '43938',
    '44847',
    '43337',
    '42759',
    '44659',
    '43338',
    '44660',
    '43048',
    '43760',
    '43143',
    '43050',
    '43340',
    '43761',
    '43144',
    '44848',
    '43830',
    '44661',
    '44662',
    '43940',
    '44441',
    '45764',
    '44849',
    '43054',
    '43981',
    '43341',
    '45662',
    '45344',
    '43762',
    '44850',
    '43764',
    '44851',
    '45766',
    '44853',
    '43984',
    '44443',
    '43766',
    '44854',
    '44445',
    '43055',
    '43056',
    '43832',
    '44444',
    '44449',
    '44665',
    '44451',
    '44666',
    '44452',
    '44070',
    '44039',
    '44856',
    '44133',
    '43619',
    '44857',
    '43767',
    '44859',
    '43449',
    '45656',
    '44074',
    '44861',
    '43768',
    '44138',
    '43616',
    '43618',
    '43146',
    '44667',
    '44109',
    '44129',
    '44131',
    '44134',
    '44142',
    '45659',
    '43450',
    '43770',
    '43551',
    '43552',
    '44864',
    '43771',
    '43147',
    '43064',
    '43772',
    '43148',
    '44865',
    '44514',
    '44866',
    '45769',
    '43452',
    '43837',
    '43451',
    '45770',
    '45662',
    '43065',
    '45669',
    '43342',
    '43773',
    '45771',
    '45672',
    '43943',
    '45772',
    '43775',
    '44867',
    '43068',
    '44286',
    '43944',
    '43344',
    '43345',
    '45674',
    '43457',
    '44270',
    '44455',
    '43777',
    '43460',
    '43346',
    '43462',
    '43150',
    '45775',
    '44460',
    '43778',
    '43945',
    '44870',
    '43779',
    '43946',
    '44874',
    '43988',
    '45678',
    '44672',
    '43780',
    '44273',
    '45776',
    '43947',
    '44274',
    '45777',
    '43782',
    '44875',
    '44878',
    '44676',
    '44677',
    '43783',
    '43152',
    '45368',
    '45680',
    '43153',
    '45369',
    '45682',
    '43702',
    '44470',
    '43350',
    '44275',
    '45501',
    '45502',
    '45503',
    '45504',
    '45505',
    '45506',
    '43950',
    '43071',
    '43786',
    '44276',
    '43952',
    '45778',
    '43787',
    '43463',
    '43154',
    '44680',
    '43961',
    '44136',
    '43155',
    '44880',
    '43788',
    '43073',
    '43962',
    '43074',
    '44882',
    '43560',
    '45780',
    '43076',
    '45685',
    '43157',
    '44883',
    '43963',
    '44887',
    '43601',
    '43602',
    '43604',
    '43605',
    '43606',
    '43607',
    '43608',
    '43609',
    '43610',
    '43611',
    '43612',
    '43613',
    '43614',
    '43615',
    '43617',
    '43620',
    '43623',
    '43624',
    '43657',
    '43660',
    '45781',
    '43964',
    '45372',
    '45782',
    '43842',
    '43158',
    '43966',
    '43351',
    '43078',
    '43080',
    '44280',
    '45889',
    '45890',
    '44089',
    '45784',
    '44281',
    '44889',
    '43465',
    '43356',
    '43843',
    '44687',
    '45785',
    '43967',
    '44481',
    '43844',
    '44490',
    '45786',
    '45688',
    '45787',
    '43566',
    '43466',
    '44688',
    '45896',
    '44090',
    '45692',
    '43968',
    '44491',
    '43162',
    '43845',
    '43357',
    '43358',
    '43163',
    '44287',
    '43081',
    '43082',
    '43086',
    '44251',
    '44145',
    '43359',
    '45694',
    '45788',
    '43791',
    '44888',
    '44890',
    '43164',
    '43468',
    '45696',
    '44689',
    '44493',
    '43953',
    '43793',
    '43469',
    '44691',
    '43085',
    '45387',
    '43971',
    '43701',
    '44697'
  ];
  const [OfferPicked, setOfferPicked] = useState(null);

  const [ZipCodeUser, setZipCodeUser] = useState(null);

  const [DominionCheck, setDominionCheck] = useState(null);

  const [ColumbiaCheck, setColumbiaCheck] = useState(null);

  const [ZipAttempt, setZipAttempt] = useState(null);

  const DominionClick = () => {
    setColumbiaCheck(false);
    setOfferPicked('Dominion');
  };

  const ColumbiaClick = () => {
    setDominionCheck(false);
    setOfferPicked('Columbia');
  };

  console.log(OfferPicked);

  const handleChange = e => {
    setZipCodeUser(e.target.value);
  };

  const ZipTest = () => {
    setDominionCheck(ZipDominion.includes(ZipCodeUser));
    setColumbiaCheck(ZipColumbia.includes(ZipCodeUser));
    setZipAttempt(true);
  };

  return (
    <div>
      <section
        className="w-full md:pt-0 md:bg-contain"
        style={{ backgroundImage: `url(${ohio_bg})` }}
      >
        <header className=" mb-9 sticky bg-blue md:bg-transparent z-50 md:static top-0 ">
          <div className="container flex flex-row sm:flex-row justify-between md:items-center md:mx-auto py-4 md:px-8">
            <div className="w-56 md:flex md:w-64 ">
              <LogoIcon />
            </div>

            <div className="mt-2 md:mt-0 flex">
              <Burger />
            </div>
          </div>
        </header>
        <div className="container mx-auto md:px-8 lg:flex">
          <div className="text-center pt-4 md:pt-20 lg:text-left lg:w-1/2">
            <Fade In duration={2000}>
              <h1 className="text-yellow text-4xl lg:text-5xl xl:text-6xl font-black leading-none">
                Some of the best rates in Ohio!
              </h1>
            </Fade>
            <Fade In duration={4000}>
              <p className="text-white text-xl lg:text-2xl mt-6 font-light">
                Kratos Ohio works diligently to get you the very best rates available. Enter your
                zip code below to see what rate we can offer you!
              </p>
              <p className="block md:hidden text-yellow text-xl lg:text-2xl mt-6 font-light">
                1. Enter Zip <br></br>2. Select Offer <br></br>3. Fill out form
              </p>
            </Fade>
            <Fade In duration={2000}>
              <div class="TopZip">
                {ZipAttempt === true ? (
                  <div>
                    {DominionCheck === false && ColumbiaCheck === false ? (
                      <form action="#" method="POST" class="mt-8 relative md:flex">
                        <input
                          name="Zip"
                          id="topZip"
                          type="number"
                          onChange={handleChange}
                          class="max-w-xs w-full px-5 py-3 leading-6 rounded-lg text-gray-900 bg-white placeholder-red"
                          placeholder="Service Area Unavailable"
                        />
                        <div class="absolute inset-y-0 left-3/4 -mt-14 md:mt-0 md:left-64 md:pl-5 flex items-center pointer-events-none">
                          <svg class="h-6 w-6 text-red" fill="currentColor" viewBox="0 0 24 24">
                            <path
                              fill-rule="evenodd"
                              d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.151 17.943l-4.143-4.102-4.117 4.159-1.833-1.833 4.104-4.157-4.162-4.119 1.833-1.833 4.155 4.102 4.106-4.16 1.849 1.849-4.1 4.141 4.157 4.104-1.849 1.849z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>

                        <div>
                          <button
                            type="button"
                            onClick={ZipTest}
                            className="mt-3 rounded-lg text-white sm:mt-0 sm:ml-3 sm:flex-shrink-0 bg-red px-14 py-3 hover:bg-darkRed transition ease-in duration-200"
                          >
                            Try Again
                          </button>
                        </div>
                      </form>
                    ) : (
                      <form action="#" method="POST" class="mt-8 relative md:flex">
                        <input
                          name="Zip"
                          id="topZip"
                          type="number"
                          class="max-w-xs w-full px-5 py-3 leading-6 rounded-lg text-green-600 bg-white duration-200"
                          disabled
                          Value={ZipCodeUser}
                        />

                        <div class="absolute inset-y-0 left-3/4 -mt-14 md:mt-0 md:left-64 md:pl-5 flex items-center pointer-events-none">
                          <svg
                            class="h-6 w-6 text-green-500"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1 17l-5-5.299 1.399-1.43 3.574 3.736 6.572-7.007 1.455 1.403-8 8.597z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>

                        <div>
                          <button
                            type="button"
                            onClick={ZipTest}
                            className="pointer-events-none mt-3 rounded-lg text-white sm:mt-0 sm:ml-3 sm:flex-shrink-0 bg-green-500 px-14 py-3 duration-500"
                          >
                            Available
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                ) : (
                  <form action="#" method="POST" class="mt-8 sm:flex">
                    <input
                      name="Zip"
                      id="topZip"
                      type="number"
                      onChange={handleChange}
                      class="max-w-xs appearance-none w-full px-5 py-3 leading-6 rounded-lg text-gray-900 bg-white placeholder-gray-500  transition duration-150 ease-in-out"
                      placeholder="Enter your Zip Code"
                    />
                    <div>
                      <button
                        type="button"
                        onClick={ZipTest}
                        className="mt-3 rounded-lg text-white sm:mt-0 sm:ml-3 sm:flex-shrink-0 bg-red px-12 py-3 hover:bg-darkRed transition ease-in duration-200"
                      >
                        Get Started
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </Fade>
          </div>
          <div className="z-10 mt-20 md:mt-0 md:w-1/2">
            <div class="topPriceCard">
              {DominionCheck === true ? (
                <div>
                  {ColumbiaCheck === true ? (
                    <div class="-mt-16 mb-1 border-2 md:border-4 border-yellow rounded-lg md:rounded-card bg-white overflow-hidden">
                      <div class="pt-4 px-2 md:px-10 md:pb-4 md:pt-6 ">
                        <h3
                          class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-medium tracking-wide uppercase bg-blue text-white"
                          id="tier-standard"
                        >
                          Dominion Energy Customers
                        </h3>
                        <div class="text-black mt-2 flex items-baseline text-4xl md:text-6xl leading-none font-extrabold">
                          $5.79
                          <span class="ml-1 text-xl md:text-2xl md:leading-8 font-medium text-gray-700">
                            /MCF
                          </span>
                          <div class="w-48 ml-24 opacity-0 md:opacity-100">
                            <img src={require('../svg/Dominion.png')} alt="Dominion Logo"></img>
                          </div>
                        </div>
                        <p class="mt-4 text-xs md:text-base md:leading-7 text-gray-600">
                          The introductory rate is for your FIRST MONTH of service. After that month
                          is up, the customer will revert to our standard month-to-month variable
                          rate. No cancellation fees or contracts.
                        </p>
                      </div>
                      <div class="pb-4 px-2 md:px-10 md:pb-5 ">
                        <div class="rounded-md">
                          <button
                            onClick={DominionClick}
                            className="mt-3 rounded-lg text-white sm:mt-0 sm:flex-shrink-0 bg-blue px-20 py-3 hover:bg-yellow transition ease-in duration-200"
                          >
                            Select Offer
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {OfferPicked === null ? (
                        <div class="-mt-16 mb-1 border-2 md:border-4 border-yellow rounded-lg md:rounded-card bg-fadedYellow overflow-hidden">
                          <div class="pt-4 px-2 md:px-10 md:pb-4 md:pt-6 ">
                            <h3
                              class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-medium tracking-wide uppercase bg-blue text-white"
                              id="tier-standard"
                            >
                              Dominion Energy Customers
                            </h3>
                            <div class="text-black mt-2 flex items-baseline text-4xl md:text-6xl leading-none font-extrabold">
                              $5.79
                              <span class="ml-1 text-xl md:text-2xl md:leading-8 font-medium text-gray-700">
                                /MCF
                              </span>
                              <div class="w-48 ml-24 opacity-0 md:opacity-100">
                                <img src={require('../svg/Dominion.png')} alt="Dominion Logo"></img>
                              </div>
                            </div>
                            <p class="mt-4 text-xs md:text-base md:leading-7 text-gray-600">
                              The introductory rate is for your FIRST MONTH of service. After that
                              month is up, the customer will revert to our standard month-to-month
                              variable rate. No cancellation fees or contracts.
                            </p>
                          </div>
                          <div class="pb-4 px-2 md:px-10 md:pb-5 ">
                            <div class="rounded-md">
                              <button
                                onClick={() => setOfferPicked('Dominion')}
                                className="mt-3 rounded-lg text-white sm:mt-0 sm:flex-shrink-0 bg-blue px-20 py-3 hover:bg-yellow transition ease-in duration-200"
                              >
                                Select to Confirm
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div class="-mt-16 mb-1 border-2 md:border-4 border-yellow rounded-lg md:rounded-card bg-fadedYellow overflow-hidden">
                          <div class="pt-4 px-2 md:px-10 md:pb-4 md:pt-6 ">
                            <h3
                              class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-medium tracking-wide uppercase bg-blue text-white"
                              id="tier-standard"
                            >
                              Dominion Energy Customers
                            </h3>
                            <div class="text-black mt-2 flex items-baseline text-4xl md:text-6xl leading-none font-extrabold">
                              $5.79
                              <span class="ml-1 text-xl md:text-2xl md:leading-8 font-medium text-gray-700">
                                /MCF
                              </span>
                              <div class="w-48 ml-24 opacity-0 md:opacity-100">
                                <img src={require('../svg/Dominion.png')} alt="Dominion Logo"></img>
                              </div>
                            </div>
                            <p class="mt-4 text-xs md:text-base md:leading-7 text-gray-600">
                              The introductory rate is for your FIRST MONTH of service. After that
                              month is up, the customer will revert to our standard month-to-month
                              variable rate. No cancellation fees or contracts.
                            </p>
                          </div>
                          <div class="pb-4 px-2 md:px-10 md:pb-5 ">
                            <div class="rounded-md">
                              <button className="text-xs md:text-base pointer-events-none mt-3 rounded-lg text-white sm:mt-0  sm:flex-shrink-0 bg-yellow px-8 md:px-16 py-3">
                                Offer Selected
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div class="zipcode opacity-75 -mt-16 border-4 border-blue rounded-lg md:rounded-card bg-white overflow-hidden">
                  <div class="pt-4 px-2 md:px-10 md:pb-4 md:pt-6 ">
                    <h3
                      class="opacity-75 inline-flex px-4 py-1 rounded-full text-sm leading-5 font-medium tracking-wide uppercase bg-gray-700 text-white"
                      id="tier-standard"
                    >
                      Dominion Energy Customers
                    </h3>
                    <div class="text-gray-600 mt-2 flex items-baseline text-4xl md:text-6xl leading-none font-extrabold">
                      $5.79
                      <span class="ml-1 text-xl md:text-2xl md:leading-8 font-medium text-gray-700">
                        /MCF
                      </span>
                      <div class="w-48 ml-24 opacity-0 md:opacity-50">
                        <img src={require('../svg/Dominion.png')} alt="Dominion Logo"></img>
                      </div>
                    </div>
                    <p class="mt-4 text-xs md:text-base md:leading-7 text-gray-600">
                      The introductory rate is for your FIRST MONTH of service. After that month is
                      up, the customer will revert to our standard month-to-month variable rate. No
                      cancellation fees or contracts.
                    </p>
                  </div>
                  <div class="pb-4 px-2 md:px-10 md:pb-5 ">
                    <div class="rounded-md">
                      <button className="text-xs md:text-base pointer-events-none mt-3 rounded-lg text-white sm:mt-0  sm:flex-shrink-0 bg-gray-700 px-8 md:px-16 py-3">
                        Enter Zip Code
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div class="bottomPriceCard">
              {ColumbiaCheck === true ? (
                <div>
                  {DominionCheck === true ? (
                    <div class="-mb-10 border-2 md:border-4 border-yellow rounded-lg md:rounded-card bg-white overflow-hidden">
                      <div class="pt-4 px-2 md:px-10 md:pb-4 md:pt-6 ">
                        <h3
                          class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-medium tracking-wide uppercase bg-yellow text-white"
                          id="tier-standard"
                        >
                          Columbia Gas Customers
                        </h3>
                        <div class="text-black mt-2 flex items-baseline text-4xl md:text-6xl leading-none font-extrabold">
                          $0.899
                          <span class="ml-1 text-xl md:text-2xl md:leading-8 font-medium text-gray-700">
                            /CCF
                          </span>
                          <div class="w-48 ml-24 opacity-0 md:opacity-100">
                            <img
                              src={require('../svg/Columbia-gas-logo.png')}
                              alt="Columbia Logo"
                            ></img>
                          </div>
                        </div>
                        <p class="mt-4 text-xs md:text-base md:leading-7 text-gray-600">
                          The introductory rate is for your FIRST MONTH of service. After that month
                          is up, the customer will revert to our standard month-to-month variable
                          rate. No cancellation fees or contracts.
                        </p>
                      </div>
                      <div class="pb-4 px-2 md:px-10 md:pb-5">
                        <div class="rounded-md">
                          <button
                            onClick={ColumbiaClick}
                            className="mt-3 rounded-lg text-white sm:mt-0 sm:flex-shrink-0 bg-blue px-20 py-3 hover:bg-yellow transition ease-in duration-200"
                          >
                            Select Offer
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {OfferPicked === null ? (
                        <div class="-mb-10 border-2 md:border-4 border-yellow rounded-lg md:rounded-card bg-fadedYellow overflow-hidden">
                          <div class="pt-4 px-2 md:px-10 md:pb-4 md:pt-6 ">
                            <h3
                              class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-medium tracking-wide uppercase bg-yellow text-white"
                              id="tier-standard"
                            >
                              Columbia Gas Customers
                            </h3>
                            <div class="text-black mt-2 flex items-baseline text-4xl md:text-6xl leading-none font-extrabold">
                              $0.899
                              <span class="ml-1 text-xl md:text-2xl md:leading-8 font-medium text-gray-700">
                                /CCF
                              </span>
                              <div class="w-48 ml-24 opacity-0 md:opacity-100">
                                <img
                                  src={require('../svg/Columbia-gas-logo.png')}
                                  alt="Columbia Logo"
                                ></img>
                              </div>
                            </div>
                            <p class="mt-4 text-xs md:text-base md:leading-7 text-gray-600">
                              The introductory rate is for your FIRST MONTH of service. After that
                              month is up, the customer will revert to our standard month-to-month
                              variable rate. No cancellation fees or contracts.
                            </p>
                          </div>
                          <div class="pb-4 px-2 md:px-10 md:pb-5">
                            <div class="rounded-md">
                              <button
                                onClick={() => setOfferPicked('Columbia')}
                                className="mt-3 rounded-lg text-white sm:mt-0 sm:flex-shrink-0 bg-blue px-20 py-3 hover:bg-yellow transition ease-in duration-200"
                              >
                                Select to Confirm
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div class="-mb-10 border-2 md:border-4 border-yellow rounded-lg md:rounded-card bg-fadedYellow overflow-hidden">
                          <div class="pt-4 px-2 md:px-10 md:pb-4 md:pt-6 ">
                            <h3
                              class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-medium tracking-wide uppercase bg-yellow text-white"
                              id="tier-standard"
                            >
                              Columbia Gas Customers
                            </h3>
                            <div class="text-black mt-2 flex items-baseline text-4xl md:text-6xl leading-none font-extrabold">
                              $0.899
                              <span class="ml-1 text-xl md:text-2xl md:leading-8 font-medium text-gray-700">
                                /CCF
                              </span>
                              <div class="w-48 ml-24 opacity-0 md:opacity-100">
                                <img
                                  src={require('../svg/Columbia-gas-logo.png')}
                                  alt="Columbia Logo"
                                ></img>
                              </div>
                            </div>
                            <p class="mt-4 text-xs md:text-base md:leading-7 text-gray-600">
                              The introductory rate is for your FIRST MONTH of service. After that
                              month is up, the customer will revert to our standard month-to-month
                              variable rate. No cancellation fees or contracts.
                            </p>
                          </div>
                          <div class="pb-4 px-2 md:px-10 md:pb-5">
                            <div class="rounded-md">
                              <button className="text-xs md:text-base pointer-events-none mt-3 rounded-lg text-white sm:mt-0  sm:flex-shrink-0 bg-yellow px-8 md:px-16 py-3">
                                Offer Selected
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div class="opacity-75 -mb-10 border-4 border-blue rounded-lg md:rounded-card bg-white overflow-hidden">
                  <div class="pt-4 px-2 md:px-10 md:pb-4 md:pt-6 ">
                    <h3
                      class="opacity-75 inline-flex px-4 py-1 rounded-full text-sm leading-5 font-medium tracking-wide uppercase bg-gray-700 text-white"
                      id="tier-standard"
                    >
                      Columbia Gas Customers
                    </h3>
                    <div class="text-gray-600 mt-2 flex items-baseline text-4xl md:text-6xl leading-none font-extrabold">
                      $0.899
                      <span class="ml-1 text-xl md:text-2xl md:leading-8 font-medium text-gray-700">
                        /CCF
                      </span>
                      <div class="w-48 ml-24 opacity-0 md:opacity-50">
                        <img
                          src={require('../svg/Columbia-gas-logo.png')}
                          alt="Dominion Logo"
                        ></img>
                      </div>
                    </div>
                    <p class="mt-4 text-xs md:text-base md:leading-7 text-gray-600">
                      The introductory rate is for your FIRST MONTH of service. After that month is
                      up, the customer will revert to our standard month-to-month variable rate. No
                      cancellation fees or contracts.
                    </p>
                  </div>
                  <div class="pb-4 px-2 md:px-10 md:pb-5">
                    <div class="rounded-md">
                      <button className="text-xs md:text-base pointer-events-none mt-3 rounded-lg text-white sm:mt-0  sm:flex-shrink-0 bg-gray-700 px-8 md:px-16 py-3">
                        Enter Zip Code
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <svg className=" opacity-0 md:opacity-100 md:-mt-64 " fill="white" viewBox="0 0 1400 300">
          <path d="M-19.22,289.89c0,0,1628.9,44.72,1673.96-672.78s782.28,718.54,782.28,718.54H-19.22V289.89z" />
        </svg>
      </section>
      <div>
        {OfferPicked === null ? (
          <div>
            <Fade In duration={2000}>
              <h1 className="text-xl container mx-auto text-center pt-8 md:pt-0 pb-8 border-b-2 lg:text-5xl font-black">
                Please enter a Zip Code to check availability
              </h1>
            </Fade>
          </div>
        ) : (
          <div>
            <Fade In duration={2000}>
              <h1 className="container mx-auto text-center pt-8 md:pt-0 pb-8 border-b-2 lg:text-5xl font-black">
                Fill out your information for service below
              </h1>
              <MainForm
                OfferPicked={OfferPicked}
                DominionCheck={DominionCheck}
                ZipCodeUser={ZipCodeUser}
              />
            </Fade>
          </div>
        )}
      </div>

      <form name="Enrollments" netlify netlify-honeypot="bot-field" data-netlify="true" hidden>
        <input type="text" name="name" />
        <input type="email" name="email" />
        <input type="text" name="address" />
        <input type="text" name="city" />
        <input type="number" name="account_number" />
        <input type="text" name="apt" />
        <input type="number" name="zip" />
        <input type="text" name="rate" />
        <input type="number" name="telephone" />
      </form>
      <VariableRateInfo />
      <FeaturedBlog />

      <div class=" text-center bg-green-500 py-14">
        {' '}
        <h1 class="max-w-3xl mx-auto text-2xl md:text-4xl font-bold text-white text-center">
          United Green Energy is now offering Green E Certified Carbon Offsets!
        </h1>
        <img
          class="mt-4 mx-auto px-8 md:px-0 w-3/4 md:w-1/5"
          src="https://imgix.cosmicjs.com/a66cd840-b5b2-11ec-a642-7195085ee56f-greene-uet-combo-white.png"
        ></img>
        <div class="mt-10 rounded-md sm:flex-shrink-0">
          <a
            href="https://ugecredits.com/"
            target="blank"
            class="w-full rounded-lg px-10 py-3 text-base font-medium rounded-md text-white bg-green-800 hover:from-blueGreen hover:bg-opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-neonGreen"
          >
            Purchase Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default App;

/*{OfferOption === 'Dominion' ? (
  <div class="-mt-16 border-4 border-yellow rounded-card bg-fadedYellow overflow-hidden">
    <div class="px-10 pb-4 pt-6 ">
      <h3
        class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-medium tracking-wide uppercase bg-blue text-white"
        id="tier-standard"
      >
        Dominion Energy Customers
      </h3>
      <div class="mt-2 flex items-baseline text-6xl leading-none font-extrabold">
        $5.79
        <span class="ml-1 text-2xl leading-8 font-medium text-gray-700">
          /MCF
        </span>
        <div class="w-48 ml-24">
          <img src={require('../svg/Dominion.png')} alt="Dominion Logo"></img>
        </div>
      </div>
      <p class="mt-4 text-md leading-7 text-gray-600">
        The introductory rate is for your FIRST MONTH of service. After that month
        is up, the customer will revert to our standard month-to-month variable
        rate. No cancellation fees or contracts.
      </p>
    </div>
    <div class="px-10 pb-5 ">
      <div class="rounded-md">
        <button
          onClick={() => setOfferOption('Dominion')}
          className="mt-3 rounded-lg text-white sm:mt-0 sm:flex-shrink-0 bg-yellow px-16 py-3"
        >
          Offer Selected
        </button>
      </div>
    </div>
  </div>
) : (
  <div class="-mt-16 border-4 border-blue rounded-lg md:rounded-card bg-white overflow-hidden hover:bg-fadedBlue transition ease-in duration-500">
    <div class="px-10 pb-4 pt-6 ">
      <h3
        class="inline-flex px-4 py-1 rounded-full text-sm leading-5 font-medium tracking-wide uppercase bg-blue text-white"
        id="tier-standard"
      >
        Dominion Energy Customers
      </h3>
      <div class="mt-2 flex items-baseline text-6xl leading-none font-extrabold">
        $5.79
        <span class="ml-1 text-2xl leading-8 font-medium text-gray-700">
          /MCF
        </span>
        <div class="w-48 ml-24">
          <img src={require('../svg/Dominion.png')} alt="Dominion Logo"></img>
        </div>
      </div>
      <p class="mt-4 text-md leading-7 text-gray-600">
        The introductory rate is for your FIRST MONTH of service. After that month
        is up, the customer will revert to our standard month-to-month variable
        rate. No cancellation fees or contracts.
      </p>
    </div>
    <div class="px-10 pb-5 ">
      <div class="rounded-md">
        <button
          onClick={() => setOfferOption('Dominion')}
          className="mt-3 rounded-lg text-white sm:mt-0 sm:flex-shrink-0 bg-blue px-20 py-3 hover:bg-yellow transition ease-in duration-200"
        >
          Select offer
        </button>
      </div>
    </div>
  </div>
)}*/
